import { render, staticRenderFns } from "./ExamList.vue?vue&type=template&id=a7d0f230&scoped=true"
import script from "./ExamList.vue?vue&type=script&lang=js"
export * from "./ExamList.vue?vue&type=script&lang=js"
import style0 from "./ExamList.vue?vue&type=style&index=0&id=a7d0f230&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d0f230",
  null
  
)

export default component.exports